import { FC } from "react";

import { HistoryJobDetails } from "./HistoryJobDetails";

export const HistoryDetailsPage: FC = () => {
  return <HistoryJobDetails />;
};
